<template>
  <div class="footer">
		<div class="bg16 cor-f ">
			<div class="bg">
				<div class="fl"></div>
				<div class="fr">
					<svgIcon iconClass="w" class="img"/>
					<!-- <img src="@/style/img/w.png" alt=""> -->
				</div>
			</div>
			<div class="w1200 flex just-between  just-center pt40 pb30">
				<div class="fl"  v-if="windowWidth > 820">
					<div class="flex align-items footerLabel fs1 ">
						<div v-for="(d,i) in menuTab" :key="i">
							<!-- <router-link :to="d.url" @click="goToUrl(d.url)"> {{d.name}}</router-link> -->
							<div  @click="goToUrl(d.url,i)"> {{d.name}}</div>
						</div>
					</div>
					<div class="li">
						<div>全国服务热线</div>400-0592-568
					</div>
					<div class="li">
						<div>企业邮箱</div>wurunjituan@wurun.net
					</div>
					<div class="li">
						<div>总部地址</div>厦门市湖里区高林中路491号天地金融港2号楼16层
					</div>
				</div>
				<div class="fr">
					<img class="logo" src="https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/footer_ico.png" alt="">
					<div class="ul" v-if="windowWidth < 820">
						<div class="li">
							<div>全国服务热线</div>400-0592-568
						</div>
						<div class="li">
							<div>企业邮箱</div>wurunjituan@wurun.net
						</div>
						<div class="li">
							<div>总部地址</div>厦门市湖里区高林中路491号天地金融港2号楼16层
						</div>
					</div>
					<div class="fs22 fw">加入我们</div>
					<div class="add fs14">五润集团诚挚欢迎，优秀专业人才和管理人才加入</div>
					<span class="addBtn" @click="goToUrl('/kefu',1)">立即加入</span>
					<div class="addImg flex align-items" v-if="windowWidth > 820">
						<div>
							<svgIcon iconClass="weixin" class="svg ico"/>
							<div class="code">
								<img src="@/style/img/code.png" alt="" srcset="">
							</div>
						</div>
						<div>
							<svgIcon iconClass="douyin" class="svg ico"/>
							<div class="code">
								<img src="@/style/img/douyin.jpg" alt="" srcset="">
							</div>
						</div>
						<div>
							<svgIcon iconClass="weibo" class="svg ico"/>
							<div class="code">
								<img src="@/style/img/weibo.jpg" alt="" srcset="">
							</div>
						</div>
						<div>
							<svgIcon iconClass="xiaochengxu" class="svg ico"/>
							<div class="code">
								<img src="@/style/img/xcx.jpg" alt="" srcset="">
							</div>
						</div>
					</div>
					<div v-if="windowWidth < 820" class="addImg flex align-items">
						<div class="code">
							<img src="@/style/img/code.png" alt="" srcset="">
						</div>
						<div class="code">
							<img src="@/style/img/douyin.jpg" alt="" srcset="">
						</div>
						<div class="code">
							<img src="@/style/img/weibo.jpg" alt="" srcset="">
						</div>
						<div class="code">
							<img src="@/style/img/xcx.jpg" alt="" srcset="">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="cor-66 center p12 code"><a href="https://beian.miit.gov.cn/" class="cor-66">闽ICP备20008706号</a>    厦门五润信息科技有限公司技术支持</div>
	</div>
</template>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?d65bae7b3cf1a86fb265960bba412a8c";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
export default {
  name: 'FooTer',
	components: {
		},
	data() {
		return {
			windowWidth: document.body.clientWidth,
			menuTab:[{
					name: '首页',
					url: '/'
				},{
					name: '走进五润',
					url: '/introduce'
				},{
					name: '集团业务',
					url: '/business'
				},{
					name: '集团生态',
					url: '/ecological'
				},{
					name: '新闻动态',
					url: '/news'
				},{
					name: '联系我们',
					url: '/kefu'
				}]
		}
	},
	mounted() {
		window.addEventListener('resize', () => this.windowWidth = window.innerWidth, false)
		this.windowWidth = document.body.clientWidth;
		var hm = document.createElement("script");
		hm.src = "https://hm.baidu.com/hm.js?d65bae7b3cf1a86fb265960bba412a8c";
		var s = document.getElementsByTagName("script")[0]; 
		s.parentNode.insertBefore(hm, s);
	},
	methods:{
		goToUrl(path,i){
			this.$bus.emit("tabIdx",i);
			this.$router.push({
				path,
				query: {
					i
				}
			})
		}
	}
}
</script>
<style scoped>
	@import url("../style/css_w/footer.css");
</style>
